import { action } from "typesafe-actions";
import { RelatorioTypes } from "./types";

export const getRelatorio = (data: any) => action(RelatorioTypes.EXTRAIR_RELATORIO_REQUEST, data);
export const getRelatorioSuccess = (data: any) => action(RelatorioTypes.EXTRAIR_RELATORIO_REQUEST_SUCCESS, { data });
export const getRelatorioFailure = (err: any) => action(RelatorioTypes.EXTRAIR_RELATORIO_REQUEST_FAILURE, { err });